import * as React from "react";
import {EvChargingQuarterState} from "../../../api/EvChargingApi";
import {quarterStateLabel} from "../evChargingBill";
import {evColors} from "../evChargingStyles";

/**
 * A quarter's state in a cell of the quarters list, as plain text; the open window, the one that needs acting on,
 * stands out.
 */
export default function QuarterState(props: { state: EvChargingQuarterState }) {
	const style: React.CSSProperties =
		props.state === "SUBMISSION_WINDOW_OPEN" ? {fontWeight: 600}
			: props.state === "SUBMISSION_WINDOW_CLOSED" ? {color: evColors.muted}
			: {};
	return <span style={style}>{quarterStateLabel(props.state)}</span>;
}
